/**
 * DEN kanoniske prisformatering for hele appen: da-DK, ALTID 2 decimaler,
 * suffiks " kr" (aldrig "DKK" / "kr."). Al prisvisning skal gå gennem
 * formatKr — kun beløb UDEN valuta (fx point og tabelceller) bruger
 * formatKrAmount. Ren formatering, ingen beregning (den ligger i src/domain).
 */

const dkk = new Intl.NumberFormat("da-DK", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** "1.234,56" — beløb uden valutasuffiks (2 decimaler, da-DK). */
export function formatKrAmount(amount: number): string {
  return dkk.format(Number.isFinite(amount) ? amount : 0);
}

/** "1.234,56 kr" — det kanoniske prisformat. */
export function formatKr(amount: number): string {
  return `${formatKrAmount(amount)} kr`;
}
